import { Box, Stack, styled, useTheme } from "@mui/material";
import type { TouchEventHandler } from "react";

const GRABBER_WIDTH = 36;
const GRABBER_HEIGHT = 5;

const GrabberBar = styled(Box)(({ theme }) => ({
	width: GRABBER_WIDTH,
	height: GRABBER_HEIGHT,
	borderRadius: theme.radii.full,
	backgroundColor: theme.palette.grey[300],
}));

type Props = {
	onTouchStart?: TouchEventHandler<HTMLDivElement>;
	onTouchMove?: TouchEventHandler<HTMLDivElement>;
	onTouchEnd?: TouchEventHandler<HTMLDivElement>;
};

export const DrawerGrabber = ({
	onTouchStart,
	onTouchMove,
	onTouchEnd,
}: Props) => {
	const { spacingTokens } = useTheme();

	return (
		<Stack
			pt={spacingTokens.md}
			pb={spacingTokens.xs}
			alignItems="center"
			flexShrink={0}
			onTouchStart={onTouchStart}
			onTouchMove={onTouchMove}
			onTouchEnd={onTouchEnd}
			sx={{ touchAction: "none" }}
		>
			<GrabberBar />
		</Stack>
	);
};
